module Pages

open Elmish.UrlParser

/// The different pages of the application. If you add a new page, then add an entry here.
[<RequireQualifiedAccess>]
type Page =
  | Home
  //| Employees
  | Contract of string
  | Contracts
  | ContractProfitFadeReport
  | Company


let toPath =
  function
  | Page.Home -> "/"
  //| Page.Employees -> "/employees"
  | Page.Contract id -> "/contract/" + id
  | Page.Contracts -> "/contracts"
  | Page.ContractProfitFadeReport -> "/profit-fade"
  | Page.Company -> "/company"

/// The URL is turned into a Result.
let pageParser : Parser<Page -> Page, _> =
  oneOf [ //Main sites
    map Page.Home (s "")
    //map Page.Employees (s "employees")
    map Page.Contract (s "contract" </> str)
    map Page.Contracts (s "contracts")
    map Page.ContractProfitFadeReport (s "profit-fade")
    map Page.Company (s "company")
  ]

let urlParser location = parsePath pageParser location

let contractUrl (id: int64) =
  toPath (Page.Contract(id.ToString().Replace("+", "")))

//let goToEmployeeDetails id =
//  Navigation.newUrl ("/employees/" + id.ToString().Replace("+", ""))
//  |> List.map (fun f -> f ignore)
//  |> ignore
